import type { UntitledIconData } from '../../UntitledIconData'

const ulUpload03: UntitledIconData = {
  prefix: 'ul',
  name: 'upload-03',
  paths: [
    {
      shape:
        'M16 12L12 8M12 8L8 12M12 8V16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z',
    },
  ],
}

export default ulUpload03
